import AgoraRTC from 'agora-rtc-sdk-ng';
import { isScreenShareAudioSupported } from '@/utils/screenShareAudioSupport';

export default {
  // create screen share tracks
  async createScreenTracks() {
    try {
      const screenAudioSupported = isScreenShareAudioSupported();

      if (screenAudioSupported) {
        const result = await AgoraRTC.createScreenVideoTrack(
          { encoderConfig: this.screenProfile },
          'auto'
        );

        if (Array.isArray(result)) {
          const [videoTrack, audioTrack] = result;
          this.localScreenTrack = videoTrack;
          this.localScreenAudioTrack = audioTrack;
          this.localTracks.push(videoTrack);
          this.localTracks.push(audioTrack);
        } else {
          this.localScreenTrack = result;
          this.localTracks.push(result);
        }
      } else {
        this.localScreenTrack = await AgoraRTC.createScreenVideoTrack({ encoderConfig: this.screenProfile });
        this.localTracks.push(this.localScreenTrack);
      }
    } catch (err) {
      throw err;
    }
  }
}
